export const isCommercialDebug: boolean =
	typeof window !== "undefined"
		? new URLSearchParams(window?.location.search).get("commercialDebug") ===
			"true"
		: false;

export const debugLog = (message: string, ...args: unknown[]): void => {
	if (isCommercialDebug) {
		// biome-ignore lint/suspicious/noConsole: we enable the logging via querystring
		console.log(`[Commercial => HYDRA] ${message}`, ...args);
	}
};

// create a named performance mark
export const markTiming = (name: string): void => {
	if (isCommercialDebug) {
		performance.mark(name);
		debugLog(`Mark: ${name}`);
	}
};
